export default __webpack_public_path__ + "static/media/a22.2eb3810b.webp";